import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { CartProvider } from "./lib/cartContext";
import { WishlistProvider } from "./lib/wishlistContext";
import { AdminAuthProvider } from "./lib/adminAuth";
import { AdminProductsProvider } from "./lib/adminProductsStore";
import { ToastProvider } from "./lib/toastContext";
import { QuickViewProvider } from "./lib/quickViewContext";
import { QuickViewModal } from "./components/QuickViewModal";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AdminAuthProvider>
        <AdminProductsProvider>
          <WishlistProvider>
            <CartProvider>
              <ToastProvider>
                <QuickViewProvider>
                  <App />
                  <QuickViewModal />
                </QuickViewProvider>
              </ToastProvider>
            </CartProvider>
          </WishlistProvider>
        </AdminProductsProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  </StrictMode>
);
